// extracted by mini-css-extract-plugin
export default {"loginGoogle":"GoogleLinkButton_loginGoogle__JR4mD"};